module.exports = __webpack_public_path__ + "img/banner-swiper1.107baa7e.png";